//@ts-check

class RentalsCaptureService {
	constructor($http, $window, $timeout, $rootScope, InternalLinksService, LocalStorageService) {
		this.$http = $http;
		this.$window = $window;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.LocalStorageService = LocalStorageService;
		this.InternalLinksService = InternalLinksService;

		this.init();
	}

	init() {
		this.utilities = [];
		this.schemeInformation = null;
		this.purchaserData = {};
		this.isSubmitted = false;
		this.maritalStatuses = [];
		this.rentalsCapture = {};
		this.contactPersonData = {};
		this.bankNames = '';
	}

	async submitClearanceCapture(clearanceHeaderId) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			if (!clearanceHeaderId) {
				throw new Error('No clearance Header Id.');
			}

			let url = await this.InternalLinksService.getLink('FinalizeClearances');

			if (!url) {
				await this.InternalLinksService.getLinks('api/clearance/links', false);
				url = await this.InternalLinksService.getLink('FinalizeClearances');
			}

			url = `${url}?clearanceHeaderId=${clearanceHeaderId}`;

			const results = await this.$http.post(url);
			this.$timeout(() => promiseHandler.resolve(results.data));
		} catch (err) {
			const msg = `Error while submitting clearance header`;
			console.error(msg, err);
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}


	async getMaritalStatuses() {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('GetMaritalStatuses');
			if (!url) {
				await this.InternalLinksService.getLinks('/api/clearance/links');
				url = await this.InternalLinksService.getLink('GetMaritalStatuses');
			}

			const results = await this.$http.get(url);
			this.maritalStatuses = results.data.filter(
				(maritalStatus) => maritalStatus.status.toLowerCase() !== 'unknown'
			);

			this.$timeout(() => promiseHandler.resolve(results.data));
		} catch (err) {
			const msg = `Error while fetching Marital Statuses`;
			console.error(msg, err);
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async uploadApplicantInfo(personalDetail, idDoc, proofOfAddressDoc, payslipDoc, bankStatementDoc) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('uploadApplicantInfo');
			if (!url) {
				await this.InternalLinksService.getLinks('/api/rentals/links');
				url = await this.InternalLinksService.getLink('uploadApplicantInfo');
			}

			let payload = {
				personalDetail: personalDetail,
				idDoc: idDoc,
				proofOfAddressDoc: proofOfAddressDoc,
				payslipDoc: payslipDoc,
				bankStatementDoc: bankStatementDoc
			};
			
			const results = await this.$http.post(url, payload);
			

			this.$timeout(() => promiseHandler.resolve(results.data));
		} catch (err) {
			const msg = `Error while uploading applicant information.`;
			console.error(msg, err);
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async uploadApplicationAcknowledgementInfo(acknowledgementDetails) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('uploadAcknowledgementDetails');
			if (!url) {
				await this.InternalLinksService.getLinks('/rentals/links');
				url = await this.InternalLinksService.getLink('uploadAcknowledgementDetails');
			}

			const results = await this.$http.post(url, acknowledgementDetails);
			const { data } = results;
			

			this.$timeout(() => promiseHandler.resolve(results.data));
		} catch (err) {
			const msg = `Error while uploading applicant acknowledgement information.`;
			console.error(msg, err);
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async uploadGeneralDetailsInfo(generalDetails, supportingDoc1, supportingDoc2, supportingDoc3) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('uploadGeneralDetails');
			if (!url) {
				await this.InternalLinksService.getLinks('/rentals/links');
				url = await this.InternalLinksService.getLink('uploadGeneralDetails');
			}

			let generalDetailsPayload = {
				generalDetails: generalDetails,
				supportDocument1: supportingDoc1,
				supportDocument2: supportingDoc2,
				supportDocument3: supportingDoc3
			};

			const results = await this.$http.post(url, generalDetailsPayload);
			const { data } = results;
			

			this.$timeout(() => promiseHandler.resolve(results.data));
		} catch (err) {
			const msg = `Error while uploading applicant acknowledgement information.`;
			console.error(msg, err);
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async uploadDeclarationsInfo(declarationDetails, firstPersonSignature, secondPersonSignature, thirdPersonSignature, fourthPersonSignature) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('uploadApplicationDeclarations');
			if (!url) {
				await this.InternalLinksService.getLinks('/rentals/links');
				url = await this.InternalLinksService.getLink('uploadApplicationDeclarations');
			}
			let declarationPayload = {
				declarationDetails: declarationDetails,
				firstPersonSignature: firstPersonSignature,
				secondPersonSignature: secondPersonSignature,
				thirdPersonSignature: thirdPersonSignature,
				fourthPersonSignature: fourthPersonSignature
			};
			const results = await this.$http.post(url, declarationPayload);
			const { data } = results;
			

			this.$timeout(() => promiseHandler.resolve(results.data));
		} catch (err) {
			const msg = `Error while uploading applicant declarations information.`;
			console.error(msg, err);
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async getRentalInitialApplication(tokenId) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('getInitialApplicationsInfo');
			if (!url) {
				await this.InternalLinksService.getLinks('/rentals/links');
				url = await this.InternalLinksService.getLink('getInitialApplicationsInfo');
			}
			url = `${url}?tokenId=${tokenId}`;
			const results = await this.$http.get(url);
			this.rentalsApplicationData = results.data;
			const { rentalsInitialApplicationData } = results;
			this.$timeout(() => promiseHandler.resolve(results.data));
		} catch (err) {
			const msg = `Error while fetching Initial Applications Information`;
			console.error(msg, err);
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

}

export default /* @ngInject */ ($http, $window, $timeout, $rootScope, InternalLinksService, LocalStorageService) =>
	new RentalsCaptureService($http, $window, $timeout, $rootScope, InternalLinksService, LocalStorageService);
